import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message, Spin } from 'antd'
import MyRichText from '../../../components/forms/richText'
import MyRadio from '../../../components/forms/radio'
import MyDocUpload from '../../../components/forms/docUpload'

const EditExercisePrescription = (props) => {
  const [formValue, setFormValue] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    axios.post('/admin/user/exercise_prescription/get', {
      user_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setFormValue(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [props.data])

  const normalizeList = (value) => {
    if (value === undefined || value === null) return []
    return Array.isArray(value) ? value : [value]
  }

  const handleOk = () => {
    axios.post('/admin/user/exercise_prescription/edit', { 
      user_oid: props.data.oid,
      mode: formValue.mode,
      part_one_rich_text: formValue.part_one_rich_text,
      part_one_url: normalizeList(formValue.part_one_url),
      part_two_rich_text: formValue.part_two_rich_text,
      part_two_url: normalizeList(formValue.part_two_url),
      part_three_rich_text: formValue.part_three_rich_text,
      part_three_url: normalizeList(formValue.part_three_url),
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          message.success('修改成功！')
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    props.isCancel()
  }

  return (
    <Modal 
      title='编辑处方详情'
      destroyOnClose={true}
      width='800px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <Spin spinning={isLoading}>
        <MyRadio
          id='mode'
          label='编辑模式'
          options={[
            {
              label: '富文本',
              value: 1,
            },
            {
              label: '文档',
              value: 2,
            }
          ]}
          defaultValue={1}
          value={formValue.mode}
          onChange={setFormValue}
        />

        {(!formValue.mode || formValue.mode === 1) && (<>
          <MyRichText
            label='第一部分'
            id='part_one_rich_text'
            value={formValue.part_one_rich_text}
            setValue={setFormValue}
          />
          <MyRichText
            label='第二部分'
            id='part_two_rich_text'
            value={formValue.part_two_rich_text}
            setValue={setFormValue}
          />
          <MyRichText
            label='第三部分'
            id='part_three_rich_text'
            value={formValue.part_three_rich_text}
            setValue={setFormValue}
          />
        </>)}

        {formValue.mode === 2 && (<>
          <MyDocUpload 
            label='第一部分'
            id="part_one_url"
            multiple
            value={formValue.part_one_url}
            setValue={setFormValue}
            setIsLoading={setIsLoading}
          />
          <MyDocUpload 
            label='第二部分'
            id="part_two_url"
            multiple
            value={formValue.part_two_url}
            setValue={setFormValue}
            setIsLoading={setIsLoading}
          />
          <MyDocUpload 
            label='第三部分'
            id="part_three_url"
            multiple
            value={formValue.part_three_url}
            setValue={setFormValue}
            setIsLoading={setIsLoading}
          />
        </>)}
      </Spin>
    </Modal>
  )
}

export default EditExercisePrescription
